export default {
  error404: {
    heading: 'Ups, Entschuldigung!',
    notFound: 'Die gesuchte Umfrage existiert nicht oder wurde verschoben.'
  }
};